import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import _ from 'lodash';
import { formatPhoneNumber } from '../../../../utils/formatters';
import ListingBadge, { BADGE_MODE } from './base';
import { isTPS, getForeclosureContact } from './utils';
export default class ForeclosureContactInformationBadge extends ListingBadge {
    static title = 'Foreclosure Contact Info';
    static titleIcon = 'phone';
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            isTPS(listing) &&
            _.isPlainObject(getForeclosureContact(listing)));
    }
    get content() {
        const contact = getForeclosureContact(this.props.listing) || {};
        return (_jsxs(_Fragment, { children: [contact.party_name, contact.party_phone && (_jsxs("div", { children: ["Borrowers/homeowners should call", ' ', _jsx("a", { href: `tel:${contact.party_phone}`, children: formatPhoneNumber(contact.party_phone) })] }))] }));
    }
}
//# sourceMappingURL=foreclosureContact.js.map